import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

export const ADMIN_TOKEN_KEY = "pulse_admin_token";

export function setAdminToken(token) {
    if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
    else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function getAdminToken() {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
}

export function authHeaders() {
    const token = getAdminToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function submitLead(payload) {
    const res = await api.post("/leads", payload);
    return res.data;
}

export async function adminLogin(password) {
    const res = await api.post("/admin/login", { password });
    return res.data;
}

export async function fetchLeads(params = {}) {
    const res = await api.get("/admin/leads", {
        headers: authHeaders(),
        params,
    });
    return res.data;
}

export async function fetchLeadStats() {
    const res = await api.get("/admin/leads/stats", { headers: authHeaders() });
    return res.data;
}

export async function updateLeadStatus(id, status) {
    const res = await api.patch(
        `/admin/leads/${id}`,
        { status },
        { headers: authHeaders() }
    );
    return res.data;
}

export async function deleteLead(id) {
    const res = await api.delete(`/admin/leads/${id}`, {
        headers: authHeaders(),
    });
    return res.data;
}

export async function verifyAdmin() {
    const res = await api.get("/admin/me", { headers: authHeaders() });
    return res.data;
}
